/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Catalog_Resolution_KeptInputs */

const en_task_catalog_resolution_kept = /** @type {(inputs: Task_Catalog_Resolution_KeptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved resolutions can be deactivated but not removed.`)
};

const pt_br2_task_catalog_resolution_kept = /** @type {(inputs: Task_Catalog_Resolution_KeptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resoluções salvas podem ser desativadas, mas não removidas.`)
};

/**
* | output |
* | --- |
* | "Saved resolutions can be deactivated but not removed." |
*
* @param {Task_Catalog_Resolution_KeptInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_resolution_kept = /** @type {((inputs?: Task_Catalog_Resolution_KeptInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Resolution_KeptInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_resolution_kept(inputs)
	return pt_br2_task_catalog_resolution_kept(inputs)
});